import axios from 'axios';
import { API_URL } from '../common/enum'

const URL = API_URL.HOST + '/user';

export const apiUser = {
    getAll(token: any) {
        return axios.get(`${URL}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    search(params: { username?: string; email?: string; role?: string; region?: string }, token: any) {
        return axios.get(`${URL}/search`, {
            params,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    register(user: any) {
        return axios.post(`${URL}/register`, user);
    },

    login(user: any) {
        return axios.post(`${URL}/login`, user);
    },

    createUser(user: any, token: any) {
        return axios.post(`${URL}`, user,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    getUserById(id: any, token: any) {
        return axios.get(`${URL}/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    updateUser(user: any, token: any) {
        const { id, ...payload } = user;
        return axios.put(`${URL}/${id}`, payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    deleteUser(id: any, token: any) {
        return axios.delete(`${URL}/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    resetPassword(user: any) {
        return axios.post(`${URL}/reset-password`, user);

    },

    changePassword(user: any, token: any) {
        const { id, ...payload } = user;
        return axios.put(`${URL}/change-password/${id}`, payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    getUserHistory(id: any, token: any) {
        return axios.get(`${URL}/history/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    searchUsers(search: { username?: string; email?: string; role?: string; region?: string }, token: any) {
        return axios.get(`${URL}/search`, {
            headers: { 'Authorization': `Bearer ${token}` },
            params: search
        });
    },

};
